module.exports = __webpack_public_path__ + "static/media/offerPackage.b79175d6.svg";